import { CSV_TEMPLATE_IMPORT } from '../index';

export const csvTemplateImportAction = (data) => {  
    return {
        type: CSV_TEMPLATE_IMPORT,
        data
    }
};